import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@digdir/designsystemet-react';
import React, { FC } from 'react';

import { useCreateV2025Registration } from '../../../registrationV2025/hooks/useRegistrationV2025Form/useCreateV2025Registration';
import { useGetUserInputReadOnly } from '../../../registration/hooks/useGetUserInput';
import { fromUserInputToFormData } from '../../../registrationV2025/pages/omBoligen/form/utils/dataMapper';
import { updateRegistration as updateRegistrationAction } from '../../../../store/registration/actions';
import { SoknadSteg } from '../../../../components/registering/utils/registerEnums';
import { SimpleBuildingRegistration } from '../../../../types/building';

interface Props {
  registrering: SimpleBuildingRegistration;
}

export const CreateSluttilstandButton: FC<Props> = ({ registrering }) => {
  const { createRegistration, createIsLoading } = useCreateV2025Registration();
  const navigate = useNavigate();
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.sluttilstand' });

  const { userInput } = useGetUserInputReadOnly(registrering.registreringId);
  const formData = fromUserInputToFormData({
    userInput,
    registreringId: registrering.registreringId
  });
  const dispatch = useDispatch();
  const onCreateSluttilstand = () => {
    // TODO: Remove redux dependency. Move registration copy logic to backend.
    dispatch(updateRegistrationAction({ userInput }));
    createRegistration(
      {
        formData,
        soknadSteg: SoknadSteg.Steg3,
        soknadId: registrering.soknadId
      },
      {
        onSuccess: (data) => {
          navigate(`../registrer-energimerke/${data.registreringId}/om-boligen`);
        }
      }
    );
  };

  return (
    <Button loading={createIsLoading} onClick={onCreateSluttilstand}>
      {t('createButton')}
    </Button>
  );
};
